import { UPLOAD_ERROR, UPLOAD_SUCCESS, UPLOAD_POST_ERROR } from "../actions/types";

export default (state = {isSwitchSnackbarOn: false, isSnackbarError: false}, action) => {
    switch (action.type) {
        case UPLOAD_SUCCESS:
            return {
                ...state,
                isSwitchSnackbarOn: true,
                isSnackbarError: false,
                loading: false,
                ErrorMessage: 'File uploaded successfully',
            };
            break;
        case UPLOAD_ERROR:
            return {    
                ...state,
                isSwitchSnackbarOn: true,
                isSnackbarError: true,
                loading: false,
                ErrorMessage: 'File upload fail',
            };
            break;
        case UPLOAD_POST_ERROR:
            return {
                ...state,
                isSwitchSnackbarOn: true,
                isSnackbarError: true,
                loading: false,
                ErrorMessage: 'Operation Error, please contact administrator.',
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/uploadReducer.js